/* Haus of Mx — Appearance toggle behaviour
 * - Persists a manual choice in localStorage ("mx-color-theme")
 * - Follows prefers-color-scheme until a manual choice is made
 * - Applies data-color-theme + color-scheme to <html>
 * - Single delegated listener (no duplicates on section re-render)
 * - Keeps every toggle instance and dynamic overlay in sync
 */
(function () {
  if (window.__mxAppearanceReady) return;
  window.__mxAppearanceReady = true;

  var KEY = 'mx-color-theme';
  var root = document.documentElement;
  var mql = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  var SIZE_REC_I18N = {
    es: {
      'Find my size': 'Encuentra tu talla',
      'Your size is': 'Tu talla es',
      'Edit': 'Editar',
      'Delete': 'Eliminar',
      'Find your size': 'Encuentra tu talla',
      'Close': 'Cerrar',
      "What's your body type?": '¿Cuál es tu tipo de cuerpo?',
      'Slim': 'Delgado/a',
      'Athletic': 'Atlético/a',
      'Regular': 'Regular',
      'Curvy': 'Con curvas',
      'What size do you usually wear?': '¿Qué talla sueles usar?',
      'How do you prefer your clothes to fit?': '¿Cómo prefieres que te quede la ropa?',
      'Fitted': 'Ajustado',
      'Relaxed': 'Holgado',
      'Oversize': 'Oversize',
      'Your recommended size is': 'Tu talla recomendada es',
      'Add to cart': 'Añadir al carrito'
    },
    fr: {
      'Find my size': 'Trouver ma taille',
      'Your size is': 'Votre taille est',
      'Edit': 'Modifier',
      'Delete': 'Supprimer',
      'Find your size': 'Trouver votre taille',
      'Close': 'Fermer',
      "What's your body type?": 'Quelle est votre morphologie ?',
      'Slim': 'Mince',
      'Athletic': 'Athlétique',
      'Regular': 'Standard',
      'Curvy': 'Avec des courbes',
      'What size do you usually wear?': 'Quelle taille portez-vous habituellement ?',
      'How do you prefer your clothes to fit?': 'Quelle coupe préférez-vous ?',
      'Fitted': 'Ajustée',
      'Relaxed': 'Ample',
      'Oversize': 'Oversize',
      'Your recommended size is': 'Votre taille recommandée est',
      'Add to cart': 'Ajouter au panier'
    },
    de: {
      'Find my size': 'Meine Größe finden',
      'Your size is': 'Deine Größe ist',
      'Edit': 'Bearbeiten',
      'Delete': 'Löschen',
      'Find your size': 'Finde deine Größe',
      'Close': 'Schließen',
      "What's your body type?": 'Welcher Körpertyp passt am besten zu dir?',
      'Slim': 'Schlank',
      'Athletic': 'Athletisch',
      'Regular': 'Normal',
      'Curvy': 'Kurvig',
      'What size do you usually wear?': 'Welche Größe trägst du normalerweise?',
      'How do you prefer your clothes to fit?': 'Wie soll deine Kleidung sitzen?',
      'Fitted': 'Eng',
      'Relaxed': 'Locker',
      'Oversize': 'Oversize',
      'Your recommended size is': 'Deine empfohlene Größe ist',
      'Add to cart': 'In den Warenkorb'
    }
  };

  function current() {
    return root.getAttribute('data-color-theme') === 'dark' ? 'dark' : 'light';
  }

  function hasManual() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'dark' || v === 'light';
    } catch (e) {
      return false;
    }
  }

  function syncOne(el) {
    var dark = current() === 'dark';
    el.setAttribute('aria-checked', dark ? 'true' : 'false');
    var next = dark ? el.getAttribute('data-label-light') : el.getAttribute('data-label-dark');
    if (next) el.setAttribute('aria-label', next);
  }

  function getSizeRecommenders() {
    var candidates = document.querySelectorAll('[class*="ai-size-rec-"]');
    var out = [];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.tagName && el.tagName.toLowerCase().indexOf('size-recommender-') === 0) out.push(el);
    }
    return out;
  }

  function replaceExactText(el, english, translated) {
    if (!el || !translated) return;
    if ((el.textContent || '').trim() === english) el.textContent = translated;
  }

  function replaceLeadingTextNode(el, english, translated) {
    if (!el || !translated) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType !== 3) continue;
      var raw = node.nodeValue || '';
      if (raw.indexOf(english) !== -1) {
        node.nodeValue = raw.replace(english, translated);
        return;
      }
    }
  }

  function localizeSizeRecommender(host) {
    var lang = (root.getAttribute('lang') || 'en').toLowerCase().split('-')[0];
    var dict = SIZE_REC_I18N[lang];
    if (!dict) return;

    replaceExactText(host.querySelector('button[data-action="open"]'), 'Find my size', dict['Find my size']);
    replaceLeadingTextNode(host.querySelector('[class*="ai-size-rec-saved-text-"]'), 'Your size is', dict['Your size is']);

    var editButtons = host.querySelectorAll('button[data-action="edit"], button[data-action="edit-result"]');
    for (var i = 0; i < editButtons.length; i++) replaceExactText(editButtons[i], 'Edit', dict.Edit);

    var deleteButtons = host.querySelectorAll('button[data-action="delete"], button[data-action="delete-result"]');
    for (var j = 0; j < deleteButtons.length; j++) replaceExactText(deleteButtons[j], 'Delete', dict.Delete);

    replaceExactText(host.querySelector('[class*="ai-size-rec-drawer-title-"]'), 'Find your size', dict['Find your size']);

    var close = host.querySelector('button[data-action="close"][class*="ai-size-rec-close-"]');
    if (close && close.getAttribute('aria-label') === 'Close') close.setAttribute('aria-label', dict.Close);

    var step1 = host.querySelector('[data-step="1"]');
    var step2 = host.querySelector('[data-step="2"]');
    var step3 = host.querySelector('[data-step="3"]');

    if (step1) {
      replaceExactText(step1.querySelector('[class*="ai-size-rec-question-"]'), "What's your body type?", dict["What's your body type?"]);
      var step1Map = { slim: 'Slim', athletic: 'Athletic', regular: 'Regular', curvy: 'Curvy' };
      Object.keys(step1Map).forEach(function (value) {
        var btn = step1.querySelector('button[data-value="' + value + '"]');
        var english = step1Map[value];
        replaceExactText(btn, english, dict[english]);
      });
    }

    if (step2) {
      replaceExactText(step2.querySelector('[class*="ai-size-rec-question-"]'), 'What size do you usually wear?', dict['What size do you usually wear?']);
    }

    if (step3) {
      replaceExactText(step3.querySelector('[class*="ai-size-rec-question-"]'), 'How do you prefer your clothes to fit?', dict['How do you prefer your clothes to fit?']);
      var step3Map = { fitted: 'Fitted', regular: 'Regular', relaxed: 'Relaxed', oversize: 'Oversize' };
      Object.keys(step3Map).forEach(function (value) {
        var btn = step3.querySelector('button[data-value="' + value + '"]');
        var english = step3Map[value];
        replaceExactText(btn, english, dict[english]);
      });
    }

    replaceLeadingTextNode(host.querySelector('[class*="ai-size-rec-result-size-"]'), 'Your recommended size is', dict['Your recommended size is']);
    replaceExactText(host.querySelector('button[data-action="add-to-cart-result"]'), 'Add to cart', dict['Add to cart']);
  }

  function syncDynamicOverlays() {
    var theme = current();
    var recommenders = getSizeRecommenders();
    for (var i = 0; i < recommenders.length; i++) {
      recommenders[i].setAttribute('data-theme', theme);
      localizeSizeRecommender(recommenders[i]);
    }
  }

  function syncAll() {
    var nodes = document.querySelectorAll('[data-mx-appearance-toggle]');
    for (var i = 0; i < nodes.length; i++) syncOne(nodes[i]);
    syncDynamicOverlays();
  }

  function apply(theme, persist) {
    root.setAttribute('data-color-theme', theme);
    root.style.colorScheme = theme;
    if (persist) {
      try { localStorage.setItem(KEY, theme); } catch (e) {}
    }
    syncAll();
  }

  function toggle() {
    apply(current() === 'dark' ? 'light' : 'dark', true);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-mx-appearance-toggle]') : null;
    if (!t) return;
    e.preventDefault();
    toggle();
  });

  if (mql) {
    var onChange = function (ev) {
      if (!hasManual()) apply(ev.matches ? 'dark' : 'light', false);
    };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }

  function boot() { syncAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('pageshow', syncAll);

  if ('MutationObserver' in window) {
    var rootObserver = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'attributes' && muts[i].attributeName === 'data-color-theme') {
          syncAll();
          break;
        }
      }
    });
    rootObserver.observe(root, { attributes: true, attributeFilter: ['data-color-theme'] });

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          syncAll();
          break;
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
